import { render, staticRenderFns } from "./ResetTransactions.vue?vue&type=template&id=c274e52a&scoped=true&"
import script from "./ResetTransactions.vue?vue&type=script&lang=js&"
export * from "./ResetTransactions.vue?vue&type=script&lang=js&"
import style0 from "./ResetTransactions.vue?vue&type=style&index=0&id=c274e52a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c274e52a",
  null
  
)

export default component.exports